import { useEffect, useState } from "react";
import { base44 } from "@/api/base44Client";
import { resolveAddress } from "@/components/AddressesSection";

// Política de autollenado de direcciones (auditoría integral):
// Las direcciones guardadas en la Libreta de Direcciones (entity Address:
// flags as_sender / as_recipient / as_shipping / is_default) NUNCA autollenan
// automáticamente ningún formulario (cotizador, generación de guías, checkout
// de la tienda, landing). La única forma de usar una dirección de la libreta es
// seleccionándola manualmente desde el botón "Libreta de Direcciones"
// (AddressBookButton), que abre el modal de direcciones guardadas.
//
// Por esa razón getPreferredAddress siempre devuelve null: no existe ningún
// autollenado automático desde la libreta. Las funciones se conservan por
// compatibilidad (pueden ser invocadas desde otros componentes), pero ya no
// resuelven ninguna dirección de forma automática.
export async function getPreferredAddress(_user, _role) {
  return null;
}

// Clasificación estricta de una dirección de la libreta (entity Address) en
// remitente (origen) o destinatario (destino). Las flags as_sender /
// as_recipient / as_shipping tienen prioridad sobre el campo `type` (que por
// defecto es "destinatario" y podía hacer que una dirección marcada solo como
// remitente apareciera también en el listado de destinatarios). Una dirección
// marcada con ambas flags aparece en ambos listados.
export function isSenderAddress(a) {
  if (!a) return false;
  if (a.as_sender) return true;
  if (a.as_recipient || a.as_shipping) return false;
  return a.type === "remitente";
}
export function isRecipientAddress(a) {
  if (!a) return false;
  if (a.as_recipient || a.as_shipping) return true;
  if (a.as_sender) return false;
  return a.type === "destinatario" || a.type === "enviar";
}

// Hook reactivo conservado por compatibilidad. Siempre devuelve null (sin
// autollenado). La suscripción a la libreta ya no es necesaria porque no hay
// nada que sincronizar, pero se mantiene el contrato del hook.
export function usePreferredAddress(_user, _role) {
  const [addr, setAddr] = useState(null);
  useEffect(() => { setAddr(null); }, []);
  return addr;
}